import { render, staticRenderFns } from "./AttributeValueDetails.vue?vue&type=template&id=366c61bd&scoped=true"
import script from "./AttributeValueDetails.vue?vue&type=script&lang=ts"
export * from "./AttributeValueDetails.vue?vue&type=script&lang=ts"
import style0 from "./AttributeValueDetails.vue?vue&type=style&index=0&id=366c61bd&lang=scss"
import style1 from "./AttributeValueDetails.vue?vue&type=style&index=1&id=366c61bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c61bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366c61bd')) {
      api.createRecord('366c61bd', component.options)
    } else {
      api.reload('366c61bd', component.options)
    }
    module.hot.accept("./AttributeValueDetails.vue?vue&type=template&id=366c61bd&scoped=true", function () {
      api.rerender('366c61bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attribute-value/components/AttributeValueDetails.vue"
export default component.exports